import moment 
  from "moment";

export function processNewUserData (users) {
    users.forEach(user => {
        user.Password = "Pass@" + user.UserName;
        preSaveDataProcessUser(user);
    });
}

export function preSaveDataProcessUser(user) {
    user.IsActive = user.IsActive !== undefined ? user.IsActive : true;
    user.UserTypeIDs = [];
    if(!user.UserTypes) user.UserTypes = [];
    user.UserTypes.forEach(userType => {
        user.UserTypeIDs.push(userType.value);
    });
    user.RegionIDs = [];

    if(!user.Regions) user.Regions = [];
    user.Regions.forEach(region => {
        user.RegionIDs.push(region.value);
    });
}

export function RecentlySyncedDataFilter(data) {
    data = data.filter(row => { 
        return moment(row.lastSyncDate) > moment().subtract(30, "days");
    });

    return data;
}

const DataServiceHelper = [
  
]

export default DataServiceHelper;